import React from 'react'

import { useTranslate } from '@hozana/intl/useTranslate'

import { Link, TLinkProps } from 'elements/text/Link'

import { useUser } from 'modules/user/hooks/useUser'

export type TUserProfileLinkProps = {
  userId: number
  message?: string
} & TLinkProps

export const UserProfileLink: TFCC<TUserProfileLinkProps> = ({
  children,
  onClick,
  userId,
  message = 'trans:common:app.link-to-profile',
  color = 'black',
  hoverColor = 'blue',
  ...otherProps
}) => {
  const user = useUser({ userId })

  return (
    <Link
      to={user?.linkToProfile}
      asButton
      onClick={userId > 0 ? onClick : undefined}
      aria-label={useTranslate(message, { name: user?.name })}
      color={color}
      hoverColor={hoverColor}
      {...otherProps}
    >
      {children}
    </Link>
  )
}
